import { useParameterStore, ValidationStatus } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { scrollToElement } from "@/frontend/utils/scrollTo";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";

export function StepRetryModal(props: { stepId: string, isDisabled: boolean }) {
  const { stepId, isDisabled } = props;
  const retryStep = useTreeStore(state => state.retryStep);
  const [showModal, setShowModal] = useState(false);
  const stepValidationsFailing = useParameterStore(useShallow(state => state.validations.filter(v => v.subjectId === stepId && state.getValidationStatus(v.id) === ValidationStatus.FAILING)));

  if (stepValidationsFailing.length === 0) {
    return null;
  }

  const onConfirm = async () => {
    setShowModal(false);
    await retryStep(stepId);
    requestAnimationFrame(() => {
      scrollToElement(stepId);
      document.getElementsByClassName('wizard-disable-container')?.[0]?.scrollTo(0, 0);
    });
  };

  return (
    <>
      <button
        className='btn btn-sm btn-warning text-nowrap my-auto'
        onClick={() => setShowModal(true)}
        type="button"
        disabled={isDisabled}
      >
        {I18n.get('retryStep')}
      </button>

      {showModal && (
        <Modal show onHide={() => setShowModal(false)}>
          <Modal.Header>
            <Modal.Title>{I18n.get('retryStep')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {I18n.get('retryStepConfirmation')}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowModal(false)}>{I18n.get('cancel')}</Button>
            <Button variant='warning' onClick={() => void onConfirm()}>{I18n.get('retryStep')}</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
